<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Change {{"Reason" | tenantWords}}</h2>
      <div class="modal-subtitle">{{this.data.record.date | date:'MM/dd/yyyy'}} · Balance {{this.data.record.balance | number:'1.0-2'}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faListCheck" class="section-icon"></fa-icon>
        <h3>{{"Reason" | tenantWords}}</h3>
      </div>
      <div class="current-reason">Current: <b>{{this.data.record.reason || '—'}}</b></div>
      <mat-form-field appearance="outline" class="reason-field">
        <mat-label>New {{"Reason" | tenantWords}}</mat-label>
        <mat-select [(ngModel)]="this.reason">
          <mat-option *ngFor="let code of this.data.reasonCodes" [value]="code.reason">{{code.reason}}</mat-option>
        </mat-select>
      </mat-form-field>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-raised-button color="primary" type="button"
      [disabled]="this.isLoading || !this.reason || this.reason === this.data.record.reason" (click)="save()">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</div>
